(function () {
  'use strict';

  function initialiseCarousel(root) {
    if (!root || root.dataset.bvmPcbCarouselReady === 'true') return;

    var rail = root.querySelector('[data-bvm-pcb-rail]');
    var previousButton = root.querySelector('[data-bvm-pcb-prev]');
    var nextButton = root.querySelector('[data-bvm-pcb-next]');

    if (!rail || !previousButton || !nextButton) return;

    root.dataset.bvmPcbCarouselReady = 'true';

    function getScrollStep() {
      var firstCard = rail.querySelector('.bvm-pcb-zero__card');
      if (!firstCard) return Math.max(rail.clientWidth * 0.8, 260);

      var railStyles = window.getComputedStyle(rail);
      var gap = parseFloat(railStyles.columnGap || railStyles.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maximumScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previousButton.disabled = rail.scrollLeft <= 2;
      nextButton.disabled = rail.scrollLeft >= maximumScroll - 2;
    }

    previousButton.addEventListener('click', function () {
      rail.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', function () {
      rail.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });

    rail.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });

    updateButtons();
    window.requestAnimationFrame(updateButtons);
  }

  function initialiseLightbox(root) {
    if (!root || root.dataset.bvmPcbLightboxReady === 'true') return;

    var lightbox = root.querySelector('[data-bvm-pcb-lightbox]');
    if (!lightbox) return;

    var image = lightbox.querySelector('[data-bvm-pcb-lightbox-image]');
    var title = lightbox.querySelector('[data-bvm-pcb-lightbox-title]');
    var closeButtons = lightbox.querySelectorAll('[data-bvm-pcb-lightbox-close]');
    var lastTrigger = null;
    var previousHtmlOverflow = '';
    var previousBodyOverflow = '';

    if (!image || !title) return;

    root.dataset.bvmPcbLightboxReady = 'true';

    function unlockPage() {
      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
    }

    function closeLightbox() {
      if (lightbox.hidden) return;

      lightbox.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      title.textContent = '';
      unlockPage();

      if (lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus();
      }
    }

    function openLightbox(trigger) {
      var source = trigger.dataset.bvmPcbLightboxSrc;
      if (!source) return;

      lastTrigger = trigger;
      previousHtmlOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;

      image.src = source;
      image.alt = trigger.dataset.bvmPcbLightboxAlt || '';
      title.textContent = trigger.dataset.bvmPcbLightboxTitle || '';
      lightbox.hidden = false;

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      var closeButton = lightbox.querySelector('.bvm-pcb-lightbox__close');
      if (closeButton) closeButton.focus();
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bvm-pcb-lightbox-open]');
      if (!trigger || !root.contains(trigger)) return;
      openLightbox(trigger);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox.hidden && event.key === 'Escape') {
        closeLightbox();
      }
    });
  }

  function initialiseAll(scope) {
    var context = scope || document;
    var carousels = context.querySelectorAll('[data-bvm-pcb-carousel]');

    carousels.forEach(function (root) {
      initialiseCarousel(root);
      initialiseLightbox(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
